import React from "react";
import { Icon, Button, Table } from "antd";
import { useDispatch } from "react-redux";
import moment from "moment";
import { Link } from "react-router-dom";
import { downloadDocument } from "../../redux/actions/orderDocuments";

const OrderDocumentsTable = props => {
  const { tableLoading, data, handleClickRow, orderId, orderNumber } = props;
  const dispatch = useDispatch();
  const columns = [
    {
      key: "name",
      title: "Название документа",
      sorter: (a, b) => {
        if (a.document_type_name >= b.document_type_name) {
          return +1;
        } else {
          return -1;
        }
      },
      render: row => {
        return (
          <div>
            <div>{row.document_type_name}</div>
            {(row.document_type_key === "clist" && (
              <div
                className={
                  row.counts.current < row.counts.total
                    ? "counts-non-complete"
                    : null
                }
              >
                Детей: {row.counts.current} из {row.counts.total}
              </div>
            )) ||
              (row.document_type_key === "alist" && (
                <div
                  className={
                    row.counts.current < row.counts.total
                      ? "counts-non-complete"
                      : null
                  }
                >
                  Сопр: {row.counts.current} из {row.counts.total}
                </div>
              )) ||
              (row.document_type_key === "plist" && (
                <div
                  className={
                    row.counts.current < row.counts.total
                      ? "counts-non-complete"
                      : null
                  }
                >
                  Пассажиров: {row.counts.current} из {row.counts.total}
                </div>
              )) ||
              (row.document_type_key === "kidsnight" && (
                <div
                  className={
                    row.counts.current < row.counts.total
                      ? "counts-non-complete"
                      : null
                  }
                >
                  Мест: {row.counts.total}
                </div>
              )) ||
              (row.document_type_key === "workphys" && (
                <div
                  className={
                    row.counts.current < row.counts.total
                      ? "counts-non-complete"
                      : null
                  }
                >
                  Работников/фл.: {row.counts.current} из {row.counts.total}
                </div>
              )) ||
              (row.document_type_key === "hwi" && (
                <div
                  className={
                    row.counts.current < row.counts.total
                      ? "counts-non-complete"
                      : null
                  }
                >
                  Работников: {row.counts.current} из {row.counts.total}
                </div>
              )) ||
              (row.document_type_key === "fplist" && (
                <div
                  className={
                    row.counts.current < row.counts.total
                      ? "counts-non-complete"
                      : null
                  }
                >
                  Продуктов: {row.counts.total}
                </div>
              ))}
          </div>
        );
      }
    },
    {
      title: "Статус",
      render: row => {
        return (
          <div>
            <div
              style={{ textTransform: "capitalize" }}
              className={
                row.status.status === "сформирован"
                  ? "table-cell-complete"
                  : "table-cell-non-complete"
              }
            >
              {row.status.status}
            </div>
            <div>{row.status.autofill ? "Автоматически" : "Вручную"}</div>
          </div>
        );
      }
    },
    {
      title: "Дата изменения",
      sorter: (a, b) => {
        const timeA = a.updated_at && moment(a.updated_at).toString();
        const timeB = b.updated_at && moment(b.updated_at).toString();
        if (timeA >= timeB) {
          return +1;
        } else {
          return -1;
        }
      },
      render: row => {
        return (
          <div>
            <div>
              {row.updated_at && moment(row.updated_at).format("DD.MM.YYYY")}
            </div>
            <div style={{ whiteSpace: "nowrap" }}>
              {row.created_at
                ? `Создан: ${moment(row.created_at).format("DD.MM.YYYY")}`
                : null}
            </div>
          </div>
        );
      }
    },
    {
      title: "Ответственный",
      render: row => {
        return <div>{!!row.is_client ? "Заказчик" : "Исполнитель"}</div>;
      }
    },
    {
      render: row => {
        return (
          <div
            style={{
              textAlign: "right",
              display: "flex",
              justifyContent: "flex-end"
            }}
          >
            {(!row.is_client && row.document_type_key === "clist" && (
              <Link to={"documents/children"}>
                <Icon
                  type="edit"
                  style={{
                    color: "#00A8FF",
                    fontSize: "24px",
                    marginRight: "16px"
                  }}
                />
              </Link>
            )) ||
              (!row.is_client && row.document_type_key === "alist" && (
                <Link to={"documents/attendants"}>
                  <Icon
                    type="edit"
                    style={{
                      color: "#00A8FF",
                      fontSize: "24px",
                      marginRight: "16px"
                    }}
                  />
                </Link>
              )) ||
              (!row.is_client && row.document_type_key === "plist" && (
                <Link to={"documents/passengers"}>
                  <Icon
                    type="edit"
                    style={{
                      color: "#00A8FF",
                      fontSize: "24px",
                      marginRight: "16px"
                    }}
                  />
                </Link>
              )) ||
              (!row.is_client && row.document_type_key === "kidsnight" && (
                <Link to={"documents/night_placement"}>
                  <Icon
                    type="edit"
                    style={{
                      color: "#00A8FF",
                      fontSize: "24px",
                      marginRight: "16px"
                    }}
                  />
                </Link>
              )) ||
              (!row.is_client && row.document_type_key === "workphys" && (
                <Link to={"documents/shippingorg"}>
                  <Icon
                    type="edit"
                    style={{
                      color: "#00A8FF",
                      fontSize: "24px",
                      marginRight: "16px"
                    }}
                  />
                </Link>
              )) ||
              (!row.is_client && row.document_type_key === "hwi" && (
                <Link to={"documents/med"}>
                  <Icon
                    type="edit"
                    style={{
                      color: "#00A8FF",
                      fontSize: "24px",
                      marginRight: "16px"
                    }}
                  />
                </Link>
              )) ||
              (!row.is_client && row.document_type_key === "arrland" && (
                <Link to={"documents/landing"}>
                  <Icon
                    type="edit"
                    style={{
                      color: "#00A8FF",
                      fontSize: "24px",
                      marginRight: "16px"
                    }}
                  />
                </Link>
              )) ||
              (!row.is_client && row.document_type_key === "fplist" && (
                <Link to={"documents/food_products"}>
                  <Icon
                    type="edit"
                    style={{
                      color: "#00A8FF",
                      fontSize: "24px",
                      marginRight: "16px"
                    }}
                  />
                </Link>
              ))}

            <Icon
              type="download"
              style={{
                color: "#00A8FF",
                fontSize: "24px",
                marginRight: "16px"
              }}
              onClick={e => {
                e.stopPropagation();
                dispatch(
                  downloadDocument({
                    orderId,
                    key: row.document_type_key,
                    orderNumber
                  })
                );
              }}
            />
          </div>
        );
      }
    }
  ];

  return (
    <div className="documents-main">
      <div className="documents-top-panel-buttons">
        {data && (
          <Button.Group>
            {data && data.meta && (
              <>
                <Button disabled={data.meta.all === 0}>
                  Все: {data.meta.all}
                </Button>
                <Button disabled={data.meta.automatic === 0}>
                  Сформирован автоматически: {data.meta.automatic}
                </Button>
                <Button disabled={data.meta.manual === 0}>
                  Заполнен вручную: {data.meta.manual}
                </Button>
              </>
            )}
          </Button.Group>
        )}
      </div>
      <Table
        className={"document-table"}
        dataSource={data && data.data}
        columns={columns}
        pagination={false}
        locale={{ emptyText: "" }}
        loading={tableLoading}
        rowKey={"document_type_key"}
        onRow={handleClickRow}
        rowSelection={{ type: "checkbox", onChange: props.onRowSelection }}
      />
    </div>
  );
};

export default OrderDocumentsTable;
